import React from 'react';
import { Dropdown, ButtonGroup } from 'react-bootstrap';
import Button from '../Button/Button';

import './DropdownButton.scss';

export interface IDropdownIndividualButtonProps {
  text: string;
  action: () => void;
}
export interface IDropdownButtonProps {
  mainButton: IDropdownIndividualButtonProps;
  subButtons?: IDropdownIndividualButtonProps[];
}

const DropdownButton = ({ mainButton, subButtons }: IDropdownButtonProps) => (
  <Dropdown align="right" as={ButtonGroup} drop="down" className="DropdownButton">
    <Button data-testid="mainButton" onClick={mainButton.action}>
      {mainButton.text}
    </Button>

    {subButtons && (
      <>
        <Dropdown.Toggle
          align="right"
          split
          id="dropdown-button-toggle"
          className="dropdown-button-toggle"
          data-tesid="dropdownButtonToggle"
          aria-label="More options dropdown"
          as={Button}
        />

        <Dropdown.Menu align="right">
          {subButtons &&
            subButtons.length > 0 &&
            subButtons.map((subButton, index) => (
              <Dropdown.Item
                onClick={subButton.action}
                key={`dropdown-menu-item-${index}-${subButton.text}`}
              >
                {subButton.text}
              </Dropdown.Item>
            ))}
        </Dropdown.Menu>
      </>
    )}
  </Dropdown>
);

DropdownButton.defaultProps = {
  subButtons: undefined,
};

export default DropdownButton;
